import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const get = async (url, params, fallback) => {
    try {
        const r = await axios.get(`${API_BASE_URL}${url}`, { params });
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const post = async (url, payload, fallback) => {
    try {
        const r = await axios.post(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const put = async (url, payload, fallback) => {
    try {
        const r = await axios.put(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

// ── Lookups ──────────────────────────────────────────────────────────────────

export const getNatureOfGroups = () => get('/Accounts/GetNatureofGroups', {}, 'Failed to fetch nature of groups');
export const getMasterGroupsByNature = (NatureGroupId) =>
    get('/Accounts/GetMasterGroupbsbyNature', { NatureGroupId }, 'Failed to fetch groups');
export const getSubGroupsByGroupId = (GroupId) =>
    get('/Accounts/GetAllSubGroupsbyGroupid', { GroupId }, 'Failed to fetch sub groups');
export const getApprovalStatusBank = (CheckType, ROID) =>
    get('/Accounts/GetapprstatusBANK', { CheckType, ROID }, 'Failed to fetch allowed actions');

// ── Grid ─────────────────────────────────────────────────────────────────────

export const getAllBankDetails = () => get('/Accounts/GetAllBankDetails', {}, 'Failed to fetch bank accounts');

// ── Save / Edit ──────────────────────────────────────────────────────────────

export const saveNewBankDetails = (payload) => post('/Accounts/SaveNewBankDetails', payload, 'Failed to save bank account');
export const updateBankDetails = (payload) => put('/Accounts/UpdateBankDetails', payload, 'Failed to update bank account');
